export default function ArrowLeftIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="arrow-left"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M21.8 38.9 8.3 25.4q-.35-.3-.475-.65Q7.7 24.4 7.7 24t.125-.75q.125-.35.475-.65L21.85 9.05q.6-.6 1.4-.575.8.025 1.35.625.6.6.6 1.4 0 .8-.6 1.4L14.5 22h23.05q.85 0 1.425.575.575.575.575 1.425 0 .85-.575 1.425Q38.4 26 37.55 26H14.5l10.15 10.15q.6.6.575 1.375-.025.775-.625 1.375t-1.4.6q-.8 0-1.4-.6Z"
      />
    </svg>
  );
}
